import React, { useRef, useEffect, useCallback } from 'react';
import { Button, Tooltip } from '@mui/material';
import PrintIcon from '@mui/icons-material/Print';
import JsBarcode from 'jsbarcode';

interface BarcodePrintButtonProps {
  barcodeData: string;
  label?: string;
  sublabel?: string;
  size?: 'small' | 'medium';
  variant?: 'text' | 'outlined' | 'contained';
}

const BarcodePrintButton: React.FC<BarcodePrintButtonProps> = ({
  barcodeData, label, sublabel, size = 'small', variant = 'text',
}) => {
  const canvasRef = useRef<HTMLCanvasElement>(null);

  useEffect(() => {
    if (canvasRef.current && barcodeData) {
      try {
        JsBarcode(canvasRef.current, barcodeData, {
          format: 'CODE128',
          width: 2,
          height: 60,
          displayValue: true,
          fontSize: 12,
          margin: 5,
        });
      } catch {
        // invalid barcode data - ignore
      }
    }
  }, [barcodeData]);

  const handlePrint = useCallback(() => {
    if (!canvasRef.current) return;
    const dataUrl = canvasRef.current.toDataURL('image/png');

    const printWindow = window.open('', '_blank', 'width=400,height=300');
    if (!printWindow) return;

    printWindow.document.write(`
      <html>
        <head>
          <title>Barkod Yazdır</title>
          <style>
            body { margin: 0; padding: 10px; font-family: Arial, sans-serif; text-align: center; }
            .label { font-size: 14px; font-weight: bold; margin-bottom: 2px; }
            .sublabel { font-size: 11px; color: #666; margin-bottom: 6px; }
            img { max-width: 100%; }
            @media print {
              body { padding: 5mm; }
            }
          </style>
        </head>
        <body>
          ${label ? `<div class="label">${label}</div>` : ''}
          ${sublabel ? `<div class="sublabel">${sublabel}</div>` : ''}
          <img src="${dataUrl}" />
        </body>
      </html>
    `);
    printWindow.document.close();
    printWindow.focus();
    setTimeout(() => {
      printWindow.print();
      printWindow.close();
    }, 300);
  }, [label, sublabel]);

  if (!barcodeData) return null;

  return (
    <>
      <canvas ref={canvasRef} style={{ display: 'none' }} />
      <Tooltip title="Barkod Yazdır">
        <Button size={size} variant={variant} onClick={handlePrint} startIcon={<PrintIcon />}
          sx={{ minWidth: 0, px: variant === 'text' ? 0.5 : undefined }}>
          {variant !== 'text' ? 'Yazdır' : ''}
        </Button>
      </Tooltip>
    </>
  );
};

export default BarcodePrintButton;
